import etZoneDataConfig from '@/api/config/etZoneDataConfig'
import { queryKeys } from '@/constant/common'
import { UpdateEtZone } from '@/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateEtZone(payload: UpdateEtZone): Promise<void> {
  await etZoneDataConfig.update(payload)
}

function useUpdateEtZone() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateEtZone) => updateEtZone(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.etZone])
      toast.success(t('updateMicroClimateSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('updateMicroClimateError'))
    },
  })
}

export default useUpdateEtZone
